<template>
  <div class="lb-breadcrumb">
    <!-- ROOT -->
    <component
      :is="rootPath.isSpa ? 'router-link' : 'a'"
      :to="rootPath.isSpa ? { path: rootPath.url } : null"
      :href="rootPath.isSpa ? null : rootPath.url"
      class="lb-breadcrumb--link"
    >
      {{ rootPath.label }}
      <Icon icon="arrow-line"
    /></component>

    <!-- PATH -->
    <component
      v-for="(link, i) in path"
      :key="link.label + link.url"
      :is="link.isSpa ? 'router-link' : 'a'"
      :to="link.isSpa ? { path: link.url } : null"
      :href="link.isSpa ? null : link.url"
      :class="{
        'lb-breadcrumb--link__current': i === path.length - 1,
        'lb-breadcrumb--link__disabled': !link.url
      }"
      class="lb-breadcrumb--link"
    >
      {{ link.label }}
      <Icon v-if="i !== path.length - 1" icon="arrow-line" />
    </component>
  </div>
</template>

<script>
/**
 * Breadcrumb utilizado dentro das páginas
 */
export default {
  name: 'Breadcrumb',
  props: {
    /**
     * Link inicial do breadcrumb - default Home
     */
    rootPath: {
      type: Object,
      default: () => {}
    },
    /**
     * Links para serem listados no caminho
     */
    path: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.lb-breadcrumb {
  display: flex;
  justify-content: flex-start;

  &--link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $gray-dark;
    font-size: font-size('size-large');
    font-weight: 300;
    cursor: pointer;

    .icon {
      width: 12px;
      margin-left: 10px;
    }

    & + .lb-breadcrumb--link {
      margin-left: 15px;
    }

    &__disabled {
      cursor: default;
      pointer-events: none;
    }
  }

  &--link__current {
    font-weight: 500;
    color: $blue;
    pointer-events: none;
    cursor: default;
  }
}
</style>
